import React from 'react';
import PropTypes from 'prop-types';

const STATUS_META = {
  0: { icon: 'fa-hourglass-half', color: 'text-info', text: 'Pending payment attempt' },
  1: { icon: 'fa-check-square', color: 'text-warning', text: 'Payment confirmed' },
  2: { icon: 'fa-check-square', color: 'text-success', text: 'Applied / completed' },
  3: { icon: 'fa-ban', color: 'text-danger', text: 'Cancelled' },
  4: { icon: 'fa-sign-out', color: 'text-secondary', text: 'Abandoned' },
  5: { icon: 'fa-clock-o', color: 'text-muted', text: 'Expired' },
  6: { icon: 'fa-times-circle', color: 'text-danger', text: 'Failed' },
};

const PaymentStatus = ({ status }) => {
  const key = Number(status);
  const meta = STATUS_META[key] || {
    icon: 'fa-question-circle',
    color: 'text-secondary',
    text: 'Unknown',
  };

  return (
    <span title={meta.text}>
      <i className={`fa ${meta.icon} ${meta.color}`}></i>
    </span>
  );
};

PaymentStatus.propTypes = {
  status: PropTypes.number.isRequired,
};

export default PaymentStatus;
